// Kate's first-party Shop (see memory: producednearby-shop-project).
// These listing types are sold only by the marketplace operator and must
// never appear in the main marketplace search grid/map - only on /shop.
export const SHOP_LISTING_TYPES = ['shop-product', 'shop-digital'];

export const isShopAdmin = currentUser =>
  currentUser?.attributes?.profile?.metadata?.role === 'admin';
